export default "__VITE_ASSET__BpvK28NJ__"